import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getKeywords = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get('/keywords', {
    params: {
      page,
      per_page: perPage,
      column: ((order || {}).column || ''),
      direction: ((order || {}).direction || 1),
      term
    }
  })
}

export const getKeyword = id => {
  return api.http.get(`/keywords/${id}`)
}

export const searchKeywords = term => {
  return api.http.get('/keywords/select_search', {
    params: {
      term
    }
  })
}

export const getSelectKeywords = (term, callback) => {
  searchKeywords(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteKeyword = id => {
  return api.http.delete(`/keywords/${id}`)
}

export const restoreKeyword = id => {
  return api.http.put(`/keywords/${id}/restore`)
}

export const editKeyword = keyword => {
  return api.http.put(`/keywords/${keyword._id}`, keyword)
}

export const addKeyword = keyword => {
  return api.http.post('/keywords', keyword)
}



// WEBPACK FOOTER //
// ./src/api/keywords.js